export const frameworksAndLibraries = ["JavaScript", "React", "Angular 2"];
